import React from 'react';
import { Card } from '../ui';
import { ShipmentContactSnapshot } from '../../services/internalShipmentService';

interface ContactSnapshotCardProps {
  title: string;
  contact?: ShipmentContactSnapshot | null;
}

const ContactSnapshotCard: React.FC<ContactSnapshotCardProps> = ({ title, contact }) => {
  const addressLine1 = [contact?.street, contact?.houseNo].filter(Boolean).join(' ');
  const addressLine2 = [
    contact?.cityName || contact?.city?.name || contact?.city_other,
    contact?.state?.name,
    contact?.zipCode,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <Card pad>
      <p className="muted" style={{ fontSize: 12, marginBottom: 4, marginTop: 0 }}>{title}</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <strong>{contact?.contactName || 'N/A'}</strong>
        <span className="muted">{contact?.companyName || 'No company'}</span>
        <span>{contact?.email || 'No email'}</span>
        <span>{contact?.phone || 'No phone'}</span>
        <span>{addressLine1 || 'No street address'}</span>
        <span>{addressLine2 || 'No city/state'}</span>
        <span>{contact?.country?.name || 'No country'}</span>
      </div>
    </Card>
  );
};

export default ContactSnapshotCard;
